import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { PrimaryCard } from "../PrimaryCards/PrimaryCard";
import styles from "./BentoBoxSection.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export var BentoBoxSection = function BentoBoxSection(_ref) {
  var primaryCardOne = _ref.primaryCardOne,
    primaryCardTwo = _ref.primaryCardTwo,
    primaryCardThree = _ref.primaryCardThree,
    primaryCardFour = _ref.primaryCardFour,
    primaryCardFive = _ref.primaryCardFive,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'v1' : _ref$version,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? 'default' : _ref$template;
  if (template === 'default') {
    return /*#__PURE__*/_jsx("div", {
      className: styles.bentoBoxSectionContainer,
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.mainBentoBoxItems, {
          [styles.fourUp]: !!primaryCardFour
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.primaryCards,
          children: [primaryCardOne && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardOne), {}, {
            idx: 1,
            options: _objectSpread(_objectSpread({}, primaryCardOne.options), {}, {
              mobileFixedHeight: true
            }),
            version: version
          })), primaryCardTwo && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardTwo), {}, {
            idx: 2,
            options: _objectSpread(_objectSpread({}, primaryCardTwo.options), {}, {
              mobileFixedHeight: true
            }),
            version: version
          }))]
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames({
            [styles.primaryCards]: !!primaryCardFour,
            [styles.mobileFullWidthCards]: !!primaryCardFour
          }),
          children: [primaryCardThree && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardThree), {}, {
            idx: 3,
            options: _objectSpread(_objectSpread({}, primaryCardThree.options), {}, {
              mobileFullWidth: true,
              extendedMobileLayout: !!primaryCardFour
            }),
            version: version
          })), primaryCardFour && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardFour), {}, {
            idx: 4,
            options: _objectSpread(_objectSpread({}, primaryCardFour.options), {}, {
              mobileFullWidth: true,
              extendedMobileLayout: !!primaryCardFour
            }),
            version: version
          })), primaryCardFive && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardFive), {}, {
            idx: 5,
            options: _objectSpread(_objectSpread({}, primaryCardFive.options), {}, {
              mobileFullWidth: true
            }),
            version: version
          }))]
        })]
      })
    });
  }
  if (template === 'warm') {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.bentoBoxSectionContainerWarm,
      children: [primaryCardOne && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardOne), {}, {
        key: 1,
        idx: primaryCardOne.desktopIdx || 1,
        options: _objectSpread(_objectSpread({}, primaryCardOne.options), {}, {
          warm: true
        }),
        version: version
      })), primaryCardTwo && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardTwo), {}, {
        key: 2,
        idx: primaryCardTwo.desktopIdx || 2,
        options: _objectSpread(_objectSpread({}, primaryCardTwo.options), {}, {
          warm: true
        }),
        version: version
      })), primaryCardThree && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardThree), {}, {
        key: 3,
        idx: primaryCardThree.desktopIdx || 3,
        options: _objectSpread(_objectSpread({}, primaryCardThree.options), {}, {
          warm: true
        }),
        version: version
      })), primaryCardFour && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardFour), {}, {
        key: 4,
        idx: primaryCardFour.desktopIdx || 4,
        options: _objectSpread(_objectSpread({}, primaryCardFour.options), {}, {
          warm: true
        }),
        version: version
      }))]
    });
  }
  if (template === 'splitGrid') {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.bentoBoxSectionContainerSplitGrid,
      children: [primaryCardOne && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardOne), {}, {
        key: 1,
        idx: primaryCardOne.desktopIdx || 1,
        options: _objectSpread({}, primaryCardOne.options),
        version: version
      })), primaryCardTwo && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardTwo), {}, {
        key: 2,
        idx: primaryCardTwo.desktopIdx || 2,
        options: _objectSpread({}, primaryCardTwo.options),
        version: version
      })), primaryCardThree && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardThree), {}, {
        key: 3,
        idx: primaryCardThree.desktopIdx || 3,
        options: _objectSpread({}, primaryCardThree.options),
        version: version
      })), primaryCardFour && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardFour), {}, {
        key: 4,
        idx: primaryCardFour.desktopIdx || 4,
        options: _objectSpread({}, primaryCardFour.options),
        version: version
      })), primaryCardFive && /*#__PURE__*/_createElement(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardFive), {}, {
        key: 5,
        idx: primaryCardFive.desktopIdx || 5,
        options: _objectSpread({}, primaryCardFive.options),
        version: version
      }))]
    });
  }
  return /*#__PURE__*/_jsx("div", {});
};